import ArrowBackRounded from "@mui/icons-material/ArrowBackRounded";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useNavigate, useOutletContext } from "react-router-dom";
import { adyogiReportsDashboardSideNavList } from "./data";
import { CustomLinearProgress } from "components/ReusableComponents/CustomLinearProgress/CustomLinearProgress";
import RareBoxLogo from "Logos/RareBoxLogo";
import { ReportsState } from "context/ReportsContext";
import ExtShopifyLiveSale from "./DashboardComponents/ExtShopifyLiveSale/ExtShopifyLiveSale";
const AdyogiExternalReports = () => {
	const [currentPath, service] = useOutletContext();
	const { reportLoading } = ReportsState();
	const navigate = useNavigate();

	const tabComponents = {
		[adyogiReportsDashboardSideNavList.shopify_live_sale.key]: {
			...adyogiReportsDashboardSideNavList.shopify_live_sale,
			component: <ExtShopifyLiveSale />,
		},
	};

	return (
		<Box sx={{ width: "100%", p: 1, pt: 0, boxSizing: "border-box" }}>
			<Box display="flex" alignItems="center" columnGap={1}>
				<IconButton onClick={() => navigate(-1)}>
					<ArrowBackRounded />
				</IconButton>
				<Typography variant="h5">{service?.name}</Typography>
			</Box>

			<Box
				width="100%"
				height="100%"
				display="flex"
				alignItems="center"
				justifyContent="center"
				sx={{ display: reportLoading ? "block" : "none" }}>
				<div
					style={{
						width: "200px",
						position: "absolute",
						left: "50%",
						top: "50%",
						transform: "translate(-50%,-50%)",
					}}>
					<RareBoxLogo />
					<CustomLinearProgress />
				</div>
			</Box>
			<Box
				width="100%"
				height="100%"
				display="flex"
				alignItems="center"
				justifyContent="center"
				sx={{ display: reportLoading ? "none" : "block" }}>
				{tabComponents?.[currentPath]?.component}
			</Box>
		</Box>
	);
};

export default AdyogiExternalReports;
